export const getUserAgent = () => {
	return navigator.userAgent.replace(/^OurPact_Android\/\d+\.\d+\.\d+ \| /, '')
}
